import {
    // FILE_UPLOAD,
    CREATE_ARCHITECTURESERVERBROADCAST,
    RETRIEVE_ARCHITECTURESERVERBROADCAST,
    RETRIEVESINGLE_ARCHITECTURESERVERBROADCAST,
    UPDATE_ARCHITECTURESERVERBROADCAST,
    DELETE_ARCHITECTURESERVERBROADCAST,
} from "./type";
import ARCServerBroadcast from "../service/arcServerBroadcast";
// export const fileUpload = (data) => async (dispatch) => {
//   try {
//     const res = await ARCServerBroadcast.fileUpload(data);
//     dispatch({
//       type: FILE_UPLOAD,
//       payload: res.data.data,
//     });
//     return Promise.resolve(res.data);
//   } catch (err) {
//     return Promise.reject(err);
//   }
// };
export const create = (data) => async (dispatch) => {
    try {
        const res = await ARCServerBroadcast.create(data);
        dispatch({
            type: CREATE_ARCHITECTURESERVERBROADCAST,
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
export const retrieve = (data) => async (dispatch) => {
    try {
        const res = await ARCServerBroadcast.fetchList(data);
        dispatch({
            type: RETRIEVE_ARCHITECTURESERVERBROADCAST,
            status: '',
            response: {},
            payload: res.data.data,
        });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const retrieveSingle = (data) => async (dispatch) => {
    try {
        const res = await ARCServerBroadcast.fetchSingle(data);
        // dispatch({
        //     type: RETRIEVESINGLE_ARCHITECTURESERVERBROADCAST,
        //     status: '',
        //     response: {},
        //     payload: res.data.data,
        // });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const update = (data) => async (dispatch) => {
    try {
        const res = await ARCServerBroadcast.update(data);
        dispatch({
            type: UPDATE_ARCHITECTURESERVERBROADCAST,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
// export const changeStatus = (data) => async (dispatch) => {
//     try {
//         const res = await ARCServerBroadcast.changeStatus(data);
//         dispatch({
//             type: UPDATE_ARCHITECTURESERVERBROADCAST,
//             status: '',
//             response: {},
//             payload: res.data,
//         });
//         return Promise.resolve(res.data);
//     } catch (err) {
//         return Promise.reject(err);
//     }
// };
export const trash = (data) => async (dispatch) => {
    try {
        const res = await ARCServerBroadcast.trash(data);
        dispatch({
            type: DELETE_ARCHITECTURESERVERBROADCAST,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};